module.exports = __webpack_public_path__ + "9b4dca23fa12f8ed63ee61676a607961.jpg";